import React from 'react';
import { BrowserRouter, Routes, Route, useParams } from 'react-router-dom';
import { EventsListPage } from './pages/EventsListPage';
import { EventPage } from './pages/EventPage';

function App() {
  return (
    <BrowserRouter>
      <Routes>
        {/* Homepage - Lista de eventos */}
        <Route path="/" element={<EventsListPage />} />
        
        {/* Rota dinâmica para cada evento */}
        <Route path="/:eventSlug/*" element={<EventRouter />} />
      </Routes>
    </BrowserRouter>
  );
}

/**
 * Router para eventos individuais
 */
function EventRouter() {
  const { eventSlug } = useParams();
  
  return <EventPage eventSlug={eventSlug} />;
}

export default App;
